"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9615],{

/***/ 22197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "NavigationBarB": function() { return /* reexport */ NavigationBarB; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
// EXTERNAL MODULE: ./src/contexts/AppContext/index.tsx + 6 modules
var AppContext = __webpack_require__(13560);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/Toolbar/Toolbar.js + 1 modules
var Toolbar = __webpack_require__(10155);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 2 modules
var Container = __webpack_require__(53156);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Menu.js
var Menu = __webpack_require__(326);
// EXTERNAL MODULE: ./src/components/Link/index.tsx
var Link = __webpack_require__(7500);
// EXTERNAL MODULE: ./src/types/enum.ts
var types_enum = __webpack_require__(95753);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/utils/useResizeObserver.ts

function useResizeObserver(refs, setMenuSliceAmount, theme) {
    (0,react.useEffect)(function() {
        var observer = new ResizeObserver(function() {
            var ref, ref1, ref2;
            var leftWidth = ((ref = refs[0].current) === null || ref === void 0 ? void 0 : ref.offsetWidth) || 0;
            var centerWidth = ((ref1 = refs[1].current) === null || ref1 === void 0 ? void 0 : ref1.offsetWidth) || 0;
            var rightWidth = ((ref2 = refs[2].current) === null || ref2 === void 0 ? void 0 : ref2.offsetWidth) || 0;
            var usedWidth = leftWidth + centerWidth + rightWidth + parseInt(theme.spacing(4).replace("px ", ""), 10);
            if (usedWidth > (window === null || window === void 0 ? void 0 : window.innerWidth)) {
                setMenuSliceAmount(function(previousState) {
                    return previousState - 1;
                });
            }
        });
        if (observer) {
            refs.forEach(function(ref) {
                if (ref.current) {
                    observer.observe(ref.current);
                }
            });
        }
        return function() {
            if (observer) {
                observer.disconnect();
            }
        };
    }, refs);
}
/* harmony default export */ var utils_useResizeObserver = (useResizeObserver);

;// CONCATENATED MODULE: ./src/utils/useDrawer.ts




var useDrawer = function(drawerAnchor, drawerSearchAnchor) {
    var ref = (0,react.useState)({
        top: false,
        left: false,
        bottom: false,
        right: false
    }), drawer = ref[0], setDrawer = ref[1];
    var ref1 = (0,react.useState)({
        top: false,
        left: false,
        bottom: false,
        right: false
    }), drawerSearch = ref1[0], setDrawerSearch = ref1[1];
    var handleToggle = function(anchorType, isOpen) {
        return function(event) {
            if (event && event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) return;
            setDrawer((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, drawer), (0,_define_property/* default */.Z)({}, anchorType, isOpen)));
        };
    };
    var handleSearchToggle = function(anchorType, isOpen) {
        return function(event) {
            if (event && event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) return;
            setDrawerSearch((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, drawerSearch), (0,_define_property/* default */.Z)({}, anchorType, isOpen)));
        };
    };
    var handleClose = function() {
        setDrawer((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, drawer), (0,_define_property/* default */.Z)({}, drawerAnchor, false)));
        setDrawerSearch((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, drawerSearch), (0,_define_property/* default */.Z)({}, drawerSearchAnchor, false)));
    };
    return {
        drawer: drawer,
        setDrawer: setDrawer,
        drawerSearch: drawerSearch,
        setDrawerSearch: setDrawerSearch,
        handleToggle: handleToggle,
        handleSearchToggle: handleSearchToggle,
        handleClose: handleClose
    };
};
/* harmony default export */ var utils_useDrawer = (useDrawer);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Search.js
var Search = __webpack_require__(51201);
;// CONCATENATED MODULE: ./src/components/NavigationbarCommon/toolbarRightContainer/ToolbarRightContainer.tsx














var LastPlayedMenu = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2214), __webpack_require__.e(5944), __webpack_require__.e(7659), __webpack_require__.e(764), __webpack_require__.e(4715), __webpack_require__.e(5978)]).then(__webpack_require__.bind(__webpack_require__, 39995)).then(function(mod) {
        return mod.LastPlayedMenu;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(39995)
            ];
        }
    },
    ssr: false
});
var LanguageSelectMenu = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2214), __webpack_require__.e(5944), __webpack_require__.e(7659), __webpack_require__.e(1458)]).then(__webpack_require__.bind(__webpack_require__, 21458)).then(function(mod) {
        return mod.LanguageSelectMenu;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(21458)
            ];
        }
    },
    ssr: false
});
var SearchField = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(89), __webpack_require__.e(1633)]).then(__webpack_require__.bind(__webpack_require__, 69614)).then(function(mod) {
        return mod.SearchField;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69614)
            ];
        }
    },
    ssr: false
});
var SearchFieldStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(SearchField, {
    target: "e16tgbq40"
})(function(param) {
    var theme = param.theme;
    return {
        flex: 1,
        margin: theme.spacing("auto", 0, "auto ", 1)
    };
});
var SearchIconStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Search/* default */.Z, {
    target: "e16tgbq41"
})(function(param) {
    var theme = param.theme;
    return {
        color: theme.theme_component_navigation_bar_icon_color || theme.palette.primary.contrastText
    };
});
var ToolbarRightContainer = function(param) {
    var handleClose = param.handleClose, setDrawerSearch = param.setDrawerSearch, drawerSearch = param.drawerSearch, drawerSearchAnchor = param.drawerSearchAnchor, children = param.children;
    var theme = (0,useTheme/* default */.Z)();
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var router = (0,next_router.useRouter)();
    var componentOptions = appContext.useConfig().componentOptions;
    var locales = (router === null || router === void 0 ? void 0 : router.locales) || [];
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(true), 2), disableLiveSearch = ref[0], setDisableLiveSearch = ref[1];
    var lastPlayedButtonDisabled = componentOptions.component_navigation_bar_last_played_button_disabled;
    var languageMenuButtonDisabled = locales.length > 1 ? componentOptions.component_navigation_bar_language_menu_button_disabled : true;
    var sm = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("sm"));
    var md = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("md"));
    react.useEffect(function() {
        handleClose();
        if (router.pathname === "/search") {
            setDisableLiveSearch(false);
        } else {
            setDisableLiveSearch(true);
        }
    }, [
        router.asPath
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            !lastPlayedButtonDisabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LastPlayedMenu, {
                size: sm ? "medium" : "small",
                edge: "start",
                variant: sm ? "standard" : "dot",
                overlap: sm ? "rectangular" : "circular"
            }),
            !languageMenuButtonDisabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LanguageSelectMenu, {
                edge: lastPlayedButtonDisabled ? "start" : undefined,
                size: sm ? "medium" : "small"
            }),
            !componentOptions.component_header_search_hidden && (md ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchFieldStyled, {
                disableLiveSearch: disableLiveSearch
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* default */.Z, {
                edge: "end",
                size: sm ? "medium" : "small",
                onClick: function() {
                    return setDrawerSearch((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, drawerSearch), (0,_define_property/* default */.Z)({}, drawerSearchAnchor, true)));
                },
                "aria-label": "search",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchIconStyled, {})
            })),
            children
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/NavigationbarCommon/drawer/index.tsx





var Drawer = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2214), __webpack_require__.e(473), __webpack_require__.e(7533), __webpack_require__.e(9484)]).then(__webpack_require__.bind(__webpack_require__, 29484)).then(function(mod) {
        return mod.Drawer;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29484)
            ];
        }
    },
    ssr: false
});
var DrawerContent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8760).then(__webpack_require__.bind(__webpack_require__, 78760)).then(function(mod) {
        return mod.DrawerContent;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(78760)
            ];
        }
    },
    ssr: false
});
var NavigationSearchResults = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(89), __webpack_require__.e(7659), __webpack_require__.e(2039), __webpack_require__.e(5869), __webpack_require__.e(4715), __webpack_require__.e(3526), __webpack_require__.e(2335)]).then(__webpack_require__.bind(__webpack_require__, 74234)).then(function(mod) {
        return mod.NavigationSearchResults;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(74234)
            ];
        }
    },
    ssr: false
});
var DrawerWrapper = function(param) {
    var drawer = param.drawer, handleToggle = param.handleToggle, drawerSearch = param.drawerSearch, handleSearchToggle = param.handleSearchToggle, children = param.children;
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var componentOptions = appContext.useConfig().componentOptions;
    var drawerSearchAnchor = componentOptions.component_navigation_bar_search_drawer_anchor || types_enum/* DrawerEnum.RIGHT */.xP.RIGHT;
    var drawerAnchor = componentOptions.component_navigation_bar_drawer_anchor || types_enum/* DrawerEnum.LEFT */.xP.LEFT;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Drawer, {
                state: drawer,
                anchor: drawerAnchor,
                onToggle: handleToggle,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DrawerContent, {
                    children: children
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Drawer, {
                state: drawerSearch,
                anchor: drawerSearchAnchor,
                onToggle: handleSearchToggle,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationSearchResults, {})
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/material/AppBar/AppBar.js + 1 modules
var AppBar = __webpack_require__(42293);
// EXTERNAL MODULE: ./src/contexts/CursorContext/Cursor.tsx
var Cursor = __webpack_require__(52746);
;// CONCATENATED MODULE: ./src/components/NavigationBar/@editor/index.ts


var useEditorHandlers = function(name) {
    var theme = (0,useTheme/* default */.Z)();
    return (0,Cursor/* useCursorHandlers */.h)({
        name: name,
        styles: [
            {
                name: "theme_component_navigation_bar_background_color",
                label: "Background color",
                type: "color",
                default: theme.palette.primary.main
            },
            {
                name: "theme_component_navigation_bar_background_image",
                label: "Background image",
                type: "text",
                startAdornment: "url(https://",
                endAdornment: "/)"
            },
            {
                name: "theme_component_navigation_bar_background_image_gradient",
                label: "Background image gradient",
                type: "text",
                helperText: "Note; any background image value gains priority over background gradient."
            },
            {
                name: "theme_component_navigation_bar_background_position",
                label: "Background position",
                type: "select",
                default: "center",
                options: [
                    "top",
                    "right",
                    "bottom",
                    "left",
                    "center"
                ]
            },
            {
                name: "theme_component_navigation_bar_background_size",
                label: "Background size",
                type: "select",
                default: "cover",
                options: [
                    "cover",
                    "contain",
                    "initial",
                    "inherit",
                    "auto"
                ]
            },
            {
                name: "theme_component_navigation_bar_background_repeat",
                label: "Background repeat",
                type: "select",
                default: "no-repeat",
                options: [
                    "no-repeat",
                    "repeat-y",
                    "repeat-x",
                    "repeat"
                ]
            },
            {
                name: "theme_component_navigation_bar_color",
                label: "Text color",
                type: "color",
                default: theme.palette.primary.contrastText
            },
            {
                name: "theme_component_navigation_bar_icon_color",
                label: "Icon color",
                type: "color",
                default: theme.palette.primary.contrastText
            },
            {
                name: "theme_component_navigation_bar_border_bottom_width",
                label: "Border bottom width",
                type: "number",
                default: 0,
                endAdornment: "px"
            },
            {
                name: "theme_component_navigation_bar_border_bottom_color",
                label: "Border bottom color",
                type: "color",
                default: theme.palette.divider
            },
            {
                type: "divider"
            },
            {
                type: "header",
                label: "Menu items"
            },
            {
                name: "theme_component_navigation_menu_item_color",
                label: "Text color",
                type: "color",
                default: theme.palette.primary.contrastText
            },
            {
                name: "theme_component_navigation_menu_item_hover_color",
                label: "Hover text color",
                type: "color",
                default: theme.palette.action.hover
            },
            {
                name: "theme_component_navigation_menu_item_hover_background_color",
                label: "Hover background color",
                type: "color",
                default: theme.palette.action.hover
            },
            {
                name: "theme_component_navigation_menu_item_active_color",
                label: "Active text color",
                type: "color",
                default: theme.palette.action.active
            },
            {
                name: "theme_component_navigation_menu_item_active_background_color",
                label: "Active background color",
                type: "color",
                default: theme.palette.action.active
            }, 
        ],
        configuration: [
            {
                name: "component_navigation_bar_layout",
                label: "Change the layout",
                type: "select",
                default: "default",
                options: [
                    "default",
                    "navigation-below"
                ]
            },
            {
                name: "component_navigation_bar_drawer_anchor",
                label: "Drawer navigation entry direction",
                type: "select",
                default: "left",
                options: [
                    "top",
                    "right",
                    "bottom",
                    "left"
                ]
            },
            {
                name: "component_navigation_bar_search_drawer_anchor",
                label: "Search drawer entry direction",
                type: "select",
                default: "right",
                options: [
                    "top",
                    "right",
                    "bottom",
                    "left"
                ]
            },
            {
                name: "component_navigation_bar_last_played_button_disabled",
                label: "Disable last played button",
                type: "checkbox",
                default: false
            },
            {
                name: "component_navigation_bar_language_menu_button_disabled",
                label: "Disable language menu button",
                type: "checkbox",
                default: false
            },
            {
                name: "component_navigation_bar_drawer_disabled",
                label: "Disable Drawer menu button",
                type: "checkbox",
                default: true
            }, 
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/NavigationBar/NavigationBar.tsx







var AppBarStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(AppBar/* default */.Z, {
    target: "elt08st0"
})(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
        backgroundColor: theme.theme_component_navigation_bar_background_color || theme.palette.primary.main,
        backgroundImage: theme.theme_component_navigation_bar_c_background_image ? "url(https://".concat(theme.theme_component_navigation_bar_c_background_image, "/)") : theme.theme_component_navigation_bar_c_background_image_gradient ? theme.theme_component_navigation_bar_c_background_image_gradient : "none",
        backgroundPosition: theme.theme_component_navigation_bar_background_position || "center",
        backgroundSize: theme.theme_component_navigation_bar_background_size || "cover",
        backgroundRepeat: theme.theme_component_navigation_bar_background_repeat || "no-repeat",
        borderBottomWidth: theme.theme_component_navigation_bar_border_bottom_width ? "".concat(theme.theme_component_navigation_bar_border_bottom_width, "px") : 0,
        borderBottomStyle: "solid",
        borderBottomColor: theme.theme_component_navigation_bar_border_bottom_color || theme.palette.divider,
        color: theme.theme_component_navigation_bar_color || theme.palette.primary.contrastText,
        outlineOffset: "-2px",
        position: theme.theme_component_navigation_position || "sticky"
    };
});
var WithNavigationbar = function(WrappedComponent) {
    var WithNavbar = function() {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppBarStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, useEditorHandlers("Navigation Bar")), {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WrappedComponent, {})
            }))
        });
    };
    return WithNavbar;
};

;// CONCATENATED MODULE: ./src/components/NavigationBarB/NavigationBarB.tsx
























var NavigationMenu = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2214), __webpack_require__.e(5944), __webpack_require__.e(8773), __webpack_require__.e(3430)]).then(__webpack_require__.bind(__webpack_require__, 3430)).then(function(mod) {
        return mod.NavigationMenu;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3430)
            ];
        }
    },
    ssr: false
});
var ToolbarLeft = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e18rj5200"
})(function() {
    return {
        display: "flex",
        justifyContent: "flex-start",
        alignSelf: "center",
        height: "56px"
    };
});
var ToolbarCenter = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e18rj5201"
})(function(param) {
    var theme = param.theme;
    return {
        flex: 1,
        display: "flex",
        justifyContent: "flex-start",
        alignSelf: "stretch",
        padding: theme.spacing(0, 2)
    };
});
var ToolbarRight = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e18rj5202"
})(function() {
    return {
        display: "flex",
        justifyContent: "flex-end",
        alignSelf: "center"
    };
});
var ButtonLogo = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Button/* default */.Z, {
    target: "e18rj5203"
})(function(param) {
    var theme = param.theme;
    return {
        width: theme.theme_component_navigation_bar_logo_width || "150px"
    };
});
var DrawerIconButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(IconButton/* default */.Z, {
    target: "e18rj5204"
})(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        marginRight: theme.spacing(2)
    }, theme.breakpoints.up("lg"), {
        display: "none"
    });
});
var DrawerIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Menu/* default */.Z, {
    target: "e18rj5205"
})(function(param) {
    var theme = param.theme;
    return {
        color: theme.theme_component_navigation_bar_icon_color || theme.palette.primary.contrastText
    };
});
var NavigationMenuContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e18rj5206"
})(function() {
    return {
        display: "flex",
        justifyContent: "center",
        padding: 0,
        margin: "auto",
        height: "100%"
    };
});
var NavigationBar = function() {
    var theme = (0,useTheme/* default */.Z)();
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var ref = appContext.useConfig(), url = ref.url, componentOptions = ref.componentOptions, assetUrl = ref.assetUrl, headerLogoId = ref.headerLogoId;
    var layout = componentOptions.component_navigation_bar_layout || types_enum/* NavigationLayoutEnum.DEFAULT */.MH.DEFAULT;
    var drawerSearchAnchor = componentOptions.component_navigation_bar_search_drawer_anchor || types_enum/* DrawerEnum.RIGHT */.xP.RIGHT;
    var drawerAnchor = componentOptions.component_navigation_bar_drawer_anchor || types_enum/* DrawerEnum.LEFT */.xP.LEFT;
    var drawerDisabled = componentOptions.component_navigation_bar_drawer_disabled || false;
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(7), 2), menuSliceAmount = ref1[0], setMenuSliceAmount = ref1[1];
    var sm = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("sm"));
    var lg = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("lg"));
    var toolBarLeftRef = react.useRef(null);
    var toolBarCenterRef = react.useRef(null);
    var toolBarRightRef = react.useRef(null);
    var refs = [
        toolBarLeftRef,
        toolBarCenterRef,
        toolBarRightRef
    ];
    utils_useResizeObserver(refs, setMenuSliceAmount, theme);
    var ref2 = utils_useDrawer(drawerAnchor, drawerSearchAnchor), drawer = ref2.drawer, setDrawer = ref2.setDrawer, drawerSearch = ref2.drawerSearch, setDrawerSearch = ref2.setDrawerSearch, handleToggle = ref2.handleToggle, handleSearchToggle = ref2.handleSearchToggle, handleClose = ref2.handleClose;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            !drawerDisabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DrawerWrapper, {
                drawer: drawer,
                handleToggle: handleToggle,
                drawerSearch: drawerSearch,
                handleSearchToggle: handleSearchToggle,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationMenu, {})
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
                maxWidth: false,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Toolbar/* default */.Z, {
                    disableGutters: true,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ToolbarLeft, {
                            ref: toolBarLeftRef,
                            children: [
                                !componentOptions.component_header_menu_hidden && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DrawerIconButton, {
                                    edge: "start",
                                    size: sm ? "medium" : "small",
                                    onClick: function() {
                                        return setDrawer((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, drawer), (0,_define_property/* default */.Z)({}, drawerAnchor, true)));
                                    },
                                    "aria-label": "menu",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DrawerIcon, {})
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonLogo, {
                                    component: Link/* Link */.r,
                                    href: "/",
                                    title: url,
                                    "aria-label": "Home",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                                        loader: function(param) {
                                            var src = param.src;
                                            return src;
                                        },
                                        src: "".concat(assetUrl).concat(headerLogoId, "/"),
                                        unoptimized: true,
                                        alt: url,
                                        layout: "fill",
                                        objectFit: "contain"
                                    })
                                })
                            ]
                        }),
                        !componentOptions.component_header_menu_hidden && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToolbarCenter, {
                            ref: toolBarCenterRef,
                            children: layout === types_enum/* NavigationLayoutEnum.DEFAULT */.MH.DEFAULT && lg && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationMenuContainer, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationMenu, {
                                    sliceAmount: menuSliceAmount
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToolbarRight, {
                            ref: toolBarRightRef,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToolbarRightContainer, {
                                setDrawerSearch: setDrawerSearch,
                                handleClose: handleClose,
                                drawerSearch: drawerSearch,
                                drawerSearchAnchor: drawerSearchAnchor
                            })
                        })
                    ]
                })
            }),
            ";"
        ]
    });
};
var NavigationBarB = WithNavigationbar(NavigationBar);


;// CONCATENATED MODULE: ./src/components/NavigationBarB/index.ts



/***/ })

}]);